import loadable from '@loadable/component';
import { BoxIndicator } from '@classtinginc/design-system';

const CreatePostPage = loadable(() => import('./CreatePostPage'), {
  fallback: <BoxIndicator />,
});

export default CreatePostPage;
